<template>
  <ProjectOpportunityList :project="project"/>
</template>

<script>
import ProjectOpportunityList from '../../../../components/Relations/ProjectOpportunities/Panels/List'

export default {
  components: {ProjectOpportunityList},

  model: {
    prop: 'project'
  },

  props: {
    project: {
      required: true,
      type: Object
    }
  }
}
</script>
